import { selectCompEditState } from 'projectRedux/store';
import { languageEditAdapter } from '../adapters/languageEditAdapter';

export const {
  selectAll: selectAllLanguageEdit,
  selectById: selectLanguageEditById,
  selectEntities: selectLanguageEditEntities,
} = languageEditAdapter.getSelectors((state) => selectCompEditState(state).languages);
